import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import { Route, Redirect, Switch } from "react-router-dom";
import { SnackbarProvider, useSnackbar } from "notistack";

import ResponsiveDrawer from "../components/Dashboard/ResponsiveDrawer";
import Customers from "./Customers";
import CustomerEdit from "./CustomerEdit";
import Licenses from "./Licenses";
import Settings from "./Settings";
import { ROLES } from "../store/auth-slice";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

const Dashboard = (props) => {
  const classes = useStyles();
  const { role } = props;
  const { enqueueSnackbar } = useSnackbar();
  const notification = useSelector((state) => state.ui.notification);

  useEffect(() => {
    if (notification) {
      enqueueSnackbar(notification.message, { variant: notification.variant });
    }
  }, [notification, enqueueSnackbar]);

  return (
    <>
      <div className={classes.root}>
        <CssBaseline />

        <ResponsiveDrawer role={role} />

        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>          
            {role === ROLES.ROLE_ADMINISTRATOR && (
              <Switch>
                <Route exact path="/">
                  <Redirect to="/customers" />
                </Route>
                <Route path="/customers/:customerId" component={CustomerEdit} />
                <Route path="/customers" component={Customers} />
                <Route path="/licenses" component={Licenses} />
                <Route path="/settings" component={Settings} />
                <Route path="*">
                  <Redirect to="/" />
                </Route>
              </Switch>
            )}
            {role === ROLES.ROLE_CUSTOMER && (
              <Switch>
                <Route exact path="/">
                  <Redirect to="/licenses" />
                </Route>
                <Route path="/licenses" component={Licenses} />
                <Route path="*">
                  <Redirect to="/" />
                </Route>
              </Switch>
            )}
          </Container>
        </main>
      </div>
    </>
  );
};

export default function IntegrationNotistack(props) {
  return (
    <SnackbarProvider maxSnack={3}>
      <Dashboard {...props} />
    </SnackbarProvider>
  );
}
